import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Select/Select.Option.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var SELECT_OPTION_CLASSNAME_MAP = {};
var SelectOption = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx("option", __spreadProps(__spreadValues({
    className: clsx("pd:select__option", className)
  }, rest), {
    children
  }));
};
var Select_Option_default = SelectOption;
export { SELECT_OPTION_CLASSNAME_MAP, Select_Option_default };